"use strict";

var _bootstrap = require("@insided/control/app/bootstrap");

(0, _bootstrap.bootstrap)();